/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { APAADMINBaseModelsNetworkStatusResponse } from '../Models';
/**
 * NetworkStatusApi - axios parameter creator
 */
export const NetworkStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [hours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkStatusGet: async (hours?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/network-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hours !== undefined) {
                localVarQueryParameter['hours'] = hours;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkStatusApi - functional programming interface
 */
export const NetworkStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetworkStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [hours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkStatusGet(hours?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsNetworkStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkStatusGet(hours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkStatusApi.apiNetworkStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NetworkStatusApi - factory interface
 */
export const NetworkStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetworkStatusApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [hours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkStatusGet(hours?: number, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsNetworkStatusResponse> {
            return localVarFp.apiNetworkStatusGet(hours, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkStatusApi - object-oriented interface
 */
export class NetworkStatusApi extends BaseAPI {
    /**
     * 
     * @param {number} [hours] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNetworkStatusGet(hours?: number, options?: RawAxiosRequestConfig) {
        return NetworkStatusApiFp(this.configuration).apiNetworkStatusGet(hours, options).then((request) => request(this.axios, this.basePath));
    }
}

